<template>
  <div class="gameCoin" ref="gameCoin">
    <div class="gameCoin-box">
      <Navbar class="nav-bar" background="transparent" :statusHeight="statusHeight"
        :backIcon="require(`@/assets/icon_back_white.png`)" :isNavtiveBack="isH5">
        <template #title>
          <span class="gameCoin-nav-title">{{
            $t('游戏币') }}</span>
        </template>
        <!-- <template #operation>
          <div class="navRight" @click="onRight">
            <span class="navRightText">{{ $t('背包') }}</span>
            <img src="@/assets/gameCoin/icon-bag.svg" class="iconBag" />
          </div>
        </template> -->
      </Navbar>
      <div class="gameCoin-detail" :style="{ paddingTop: (statusHeight + 24 + 44) + 'px' }">
        <div class="balanceRow px-14px">
          <div class="balanceLeft">
            <span :class="['balanceLabel', language]">{{ $t('游戏币余额:') }}</span>
            <div class="balanceValue">
              <span class="balanceNum">{{ gameCoin }}</span>
              <img src="@/assets/gameCoin/game-coin-icon.png" class="balanceCoin" />
            </div>
          </div>
          <div class="ruleBtn flex algin-center" @click="goDetails">
            <span :class="['ruleText', language === 'ug' && 'ug-normal']">{{ $t('明细') }}</span>
            <img src="@/assets/gameCoin/coin-detail-icon.webp" class="ruleIcon" />
          </div>
        </div>
        <div class="balanceDiamond px-14px">
          <div class="balanceLeft">
            <span :class="['balanceLabel', language]">{{ $t('当前剩余金币: ') + ' ' }}</span>
            <p class="balanceNum">{{ goldCoin }}</p>
          </div>
          <div class="ruleBtn flex algin-center" @click="showGoldCoinCharge">
            <span :class="['ruleText', language === 'ug' && 'ug-normal']">{{ $t('充金币') }}</span>
            <img src="@/assets/gameCoin/coin-detail-icon-diamond.webp" class="ruleIcon" />
          </div>
        </div>
        <!-- <div class="gameCoinTab px-14px">
          <div
            :class="['tab-item', language === 'ug' && 'ug-normal tab-item-ug', activeTabId === 1 && 'tab-item-active']"
            @click="handleClick(1)">{{ $t('游戏币兑换') }}
          </div>
          <div
            :class="['tab-item', language === 'ug' && 'ug-normal tab-item-ug', activeTabId === 2 && 'tab-item-active']"
            @click="handleClick(2)">{{
              $t('购买游戏币')
            }}</div>
        </div> -->
        <div class="container">
          <van-swipe ref="swipe"  :loop="false" :show-indicators="false" @change="onChange" :autoplay="0">
            <!-- <van-swipe-item class="px-14px">
              <CoinConvert :dataPops="convertList" ref="coinConvert" @handleShowPopup="handleShowPopup" :gameCoin="gameCoin"
                :buyList="buyList" :refreshUserInfo="refreshUserInfo">
              </CoinConvert>
            </van-swipe-item> -->
            <van-swipe-item class="px-14px">
              <CoinBuy :gap="12" :dataPops="buyList" ref="coinBuy" @handleShowPopup="handleShowPopup"
                :refreshUserInfo="refreshUserInfo">
              </CoinBuy>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <ConfirmPopup :showPopup.sync="showPopup" @confirmExchange="confirmExchange" :popupObj="popupObj" />
  </div>
</template>

<script>
import { appFunc_senToken, appFunc_changeBar, appFunc_LiveCoinsExchangeDetail, appFunc_LiveCoinsExchangeBackpack, appFunc_LiveCoinsExchangeBuyGold, jsFunc_UserInfoRefreshCallBack } from '@/utils/bridge'
import { CommonModule } from '@/store/modules/common'
import Navbar from '@/components/Navbar.vue';
// import CoinConvert from './components/CoinConvert.vue';
import CoinBuy from './components/CoinBuy.vue';
import ConfirmPopup from './components/ConfimPopup.vue'
import { diamondExchangeGameCoinConfigList, gameCoinExchangeList, getLoginUserInfo } from '@/api'
import { Swipe, SwipeItem } from 'vant';

export default {
  components: {
    Navbar,
    // CoinConvert,
    CoinBuy,
    ConfirmPopup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  computed: {
    resultGameCoin() {
      return this.$t('游戏币余额: xx', {count:  `<span class="harmonyOs_bold fontSize-24">${this.gameCoin}</span>`})
    }
  },
  data() {
    return {
      isH5: false,
      statusHeight: 0,
      background: 'transparent',
      nobleList: [],
      userNoble: {},
      activedId: 0,
      gameCoin: 0,
      goldCoin: 0,
      activeTabId: 1,
      buyList: [],
      convertList: [],
      language: 'ug',
      showPopup: false,
      popupObj: {
        popupTitle: '',
        sureText: '',
        configId: undefined,
        isUse: false
      }
    }
  },
  methods: {
    handleShowPopup(popupObj) {
      this.popupObj = {
        popupTitle: '',
        sureText: '',
        configId: undefined,
        isUse: false,
        isusePop: false,
        ...popupObj
      }
      this.showPopup = true
    },
    async confirmExchange() {
      let resolve = null

      if (this.popupObj.popupTitle === '兑换游戏币') { // 兑换游戏币
        resolve = await this.$refs.coinBuy.confirmExchange(this.popupObj?.configId)
      } else { // 兑换钻石
        if (this.popupObj?.configId) {
          resolve = await this.$refs.coinBuy.confirmExchange(this.popupObj?.configId)
        } else {
          if (this.popupObj?.isUse) {
            resolve = await this.$refs.coinConvert.confirmUse()
          } else {
            // 特殊处理-使用弹窗
            resolve = await this.$refs.coinConvert.confirmExchange()
            if (resolve) {
              this.showPopup = false
              if(!resolve.isusePop) return // 装扮才弹使用弹窗
              return setTimeout(() => this.handleShowPopup(resolve), 200)
            }
          }
        }
      }
      // 兑换成功后关闭弹窗
      resolve !== null && (this.showPopup = false)
    },
    handleClick(index) {
      this.$refs['swipe'].swipeTo(index - 1)
      this.activeTabId = index
    },
    onChange(index) {
      this.activeTabId = index + 1
    },
    refreshUserInfo() {
      getLoginUserInfo().then(res => {
        if(res.code === 1001 && res.data) {
          this.gameCoin = res.data.gameCoin
          this.goldCoin = res.data.goldCoin
        }
      })
    },
    getGameCoinConfigList() {
      diamondExchangeGameCoinConfigList().then(res => {
        if(res.code === 1001 && res.data) {
          this.buyList = res.data
        }
      })
    },
    getCoinExchangeList() {
      gameCoinExchangeList().then(res => {
        if(res.code === 1001 && res.data) {
          this.convertList = res.data
        }
      })
    },
    onRight() {
      appFunc_LiveCoinsExchangeBackpack()
    },
    goDetails() {
      appFunc_LiveCoinsExchangeDetail()
    },
    showGoldCoinCharge() {
      appFunc_LiveCoinsExchangeBuyGold()
    },
    setLanguage() {
      // 获取当前语言
      console.log('setLanguage', window.location.href)
      const data = this.$route.query.language || 'ug'
      this.language = data
      this.$i18n.locale = data
      CommonModule.setLanguage(data)
    },
    async getToken() {
      const res = await appFunc_senToken()
      console.log(res, '/////////////')
      CommonModule.setUserId(res.id)
      CommonModule.setToken(res.tokenForJs)
      CommonModule.setUserPhone(res.mobile)
      CommonModule.setUserName(res.name)
    },
    // 刷新用户信息
    handlerBridgeRefreshUserInfo() { 
      jsFunc_UserInfoRefreshCallBack(this.refreshUserInfo)
    }
  },
  async created() {
    this.setLanguage();
    this.isH5 = this.$route.query.isH5 === 'true' ? false : true;
    this.statusHeight = +this.$route.query.statusBarHeight || 0;
    this.activeTabId = (+this.$route.query.index || 0) + 1
    this.$nextTick(() => this.$refs['swipe'].swipeTo(this.activeTabId - 1))
    appFunc_changeBar({ statusBarModel: false, navBarBackground: '#251B5C' })
    // await this.getToken()
    this.refreshUserInfo()
    this.getGameCoinConfigList()
    this.getCoinExchangeList()
    this.handlerBridgeRefreshUserInfo()
  },
}
</script>

<style lang="scss" scoped>
.gameCoin {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #251B5C;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 244px;
    background: url('../../assets/gameCoin/bg-top.svg') no-repeat;
    background-size: contain;
    transition: all .3s ease-in-out;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .gameCoin-box {
    height: 100%;
    z-index: 999;
    position: relative;

    .gameCoin-nav-title {
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
    }

    .nav-bar {
      display: block;
      position: fixed;
      width: 100vw;
      box-sizing: border-box;
      z-index: 999;
      padding: 0;
      background-color: transparent;
    }

    .gameCoin-detail {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
    }
  }

  .navRight {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    padding-right: 5px;

    .iconBag {
      width: 14px;
      height: 14px;
      margin-left: 4px;
    }
  }
}

.gameCoin-afterBox::after {
  height: 0;
}

.px-14px {
  padding: 0 14px;
  box-sizing: border-box;
}

.flex-ac {
  display: flex;
  align-items: center;
}

.balanceRow {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .balanceLeft {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    

    .balanceValue {
      display: flex;
      align-items: center;
      margin-left: 5px;
      .balanceNum {
        font-size: 24px;
        font-family: 'HarmonyOs_Bold';
      }
      img {
        width: 28px;
        height: 28px;
        margin-left: 3px;
      }
    }
  }

  .ruleBtn {
    font-weight: 400;
    font-size: 12px;
    color: #D1C7C7;

    img {
      width: 12px;
      height: 12px;
    }
  }
}

.balanceDiamond {
  display: flex;
  align-items: center;
  padding-top: 9px;
  font-size: 12px;

  .balanceLeft {
    display: flex;
    padding-right: 32px;
    color: rgba($color: #ffffff, $alpha: 0.8); 
  }

  .balanceNum {
    font-family: 'HarmonyOs_Medium';
  }
  .ruleBtn {
    font-weight: 400;
    color: #B975FF;

    img {
      width: 12px;
      height: 12px;
    }
  }
}

.gameCoinTab {
  display: flex;
  justify-content: center;
  padding-top: 9px;

  .tab-item {
    width: 159px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    background: url('../../assets/gameCoin/tab-nselect.webp') no-repeat;
    background-size: cover;
  }

  .tab-item-ug {
    font-size: 13px;
  }

  .tab-item:first-child {
    margin-right: 15px;
  }

  .tab-item-active {
    background-image: url('../../assets/gameCoin/tab-select.webp');
  }
}

.container {
  flex: 1;
  padding-bottom: 22px;
  overflow-y: hidden;
}

::v-deep .van-swipe {
  height: 100%;
}
</style>